export const text = {
  0: '0.75rem',
  1: '1rem',
  2: '1.25rem',
  3: '1.5rem',
  4: '2rem',
  5: '2.15rem',
  6: '2.3rem',
};

export const spacing = {
  0: '10px',
  1: '20px',
  2: '30px',
  3: '40px',
  4: '60px',
  5: '80px',
};

export const lineHeight = {
  0: '115%',
  1: '125%',
  2: '150%',
  3: '166%',
  4: '200%',
};

enum MaxScreenSizes {
  sm = 641,
  md = 769,
  lg = 1025,
  xl = 1281,
  xxl = 1781,
}

interface Sizes {
  sm: string;
  md: string;
  lg: string;
  xl: string;
  xxl: string;
}

const sizes: Sizes = {
  sm: `${MaxScreenSizes.sm}px`,
  md: `${MaxScreenSizes.md}px`,
  lg: `${MaxScreenSizes.lg}px`,
  xl: `${MaxScreenSizes.xl}px`,
  xxl: `${MaxScreenSizes.xxl}px`,
};

export const device = {
  sm: `(max-width: ${sizes.sm})`,
  md: `(min-width: ${sizes.sm})`,
  lg: `(min-width: ${sizes.md})`,
  xl: `(min-width: ${sizes.lg})`,
  xxl: `(min-width: ${sizes.xl})`,
  xxxl: `(min-width: ${sizes.xxl})`,
};
